var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcMenuToolsUcBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#660099;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M384.8,298.4c3.8-4.3,10.5-4.6,14.7-0.8s4.6,10.5,0.8,14.7c-2.3,2.5-56.1,61.1-148.7,62.2 c-1.3,0.1-2.6,0.1-3.8,0.1c-18.4,0-96.5-3.6-148.1-61.3c-3.8-4.3-3.4-10.9,0.9-14.7c4.3-3.8,10.9-3.4,14.7,0.9 c51.2,57.3,135,54.4,135.8,54.3C334.5,352.8,384.3,298.9,384.8,298.4L384.8,298.4z M249.9,479.2c152.1,0,229.2-77,229.2-229.1 C479.2,98,402,20.8,249.9,20.8C97.9,20.8,20.8,98,20.8,250.1C20.8,402.1,97.9,479.2,249.9,479.2z M249.9,0 C407.9,0,500,79.8,500,250.1S407.9,500,249.9,500S0,420.4,0,250.1S92,0,249.9,0z M174.2,210.5c-8.3,0-15.2-2.6-20-7.4 c-4.7-4.8-7-11.4-7-19.7c0-16.9,10.1-27.1,27-27.1s27,10.2,27,27.1c0,8.3-2.3,14.9-7,19.7C189.4,208,182.5,210.5,174.2,210.5z  M325.8,210.5c-8.3,0-15.2-2.6-20-7.4c-4.7-4.8-7-11.4-7-19.7c0-16.9,10.1-27.1,27-27.1s27,10.2,27,27.1c0,8.3-2.3,14.9-7,19.7 C341.1,208,334.2,210.5,325.8,210.5L325.8,210.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcMenuToolsUcBlue);
export default __webpack_public_path__ + "static/media/ic-menu-tools-uc-blue.bb9d75fb06ac2aecd4f89925dbdb51ca.svg";
export { ForwardRef as ReactComponent };